import React from "react"

import { checkAuth } from "../../apiRequests/auth"

import AdaptiveLink from "../../components/AdaptiveLink"

import styles from "./styles.module.styl"

import { pagesLinks } from "../../pages-data/common/links"

const AUTH_STATUSES = {
	PENDING: "PENDING",
	AUTHORIZED: "AUTHORIZED",
	NOT_AUTHORIZED: "NOT_AUTHORIZED",
}

export default class SignIn extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			authStatus: AUTH_STATUSES.PENDING,
		}
	}

	componentDidMount = async () => {
		const isUserAuthorized = await checkAuth()

		this.setState({
			authStatus: isUserAuthorized
				? AUTH_STATUSES.AUTHORIZED
				: AUTH_STATUSES.NOT_AUTHORIZED,
		})
	}

	render() {
		return (
			<div
				className={`
                    ${
											this.state.authStatus === AUTH_STATUSES.PENDING
												? styles.signIn__loader
												: styles.signIn
										}
                    ${this.props.className || ""}
                `}
			>
				<AdaptiveLink
					className={styles.signIn__link}
					href={
						this.state.authStatus === AUTH_STATUSES.AUTHORIZED
							? pagesLinks.personal.href
							: pagesLinks.login.href
					}
				>
					{this.state.authStatus === AUTH_STATUSES.AUTHORIZED
						? pagesLinks.personal.text
						: pagesLinks.login.text}
				</AdaptiveLink>
			</div>
		)
	}
}
